import React from 'react'
import Nav from './Nav'
import logo from 'assets/logo.svg'

const Header = () => {
  return (
    <div className="bg-white flex h-24 py-4 px-4 justify-start shadow-md">
      <img src={logo} className="w-24 h-17" alt="Taskly Logo" />
      <Nav />
    </div>
  )
}

export default Header
